import { Card, CardContent, Grid } from '@mui/material';
import { FormInput } from '../../../components/hook-form/form-input.component';
import { useFormContext } from 'react-hook-form';
import { ProjectType } from '../../../models/project';
import { projectsApiKeyStore } from '../../../api/projects-api-key-store';
import useDebounce from '../../../hooks/use-debounce';
import { useLoadData } from '../../../hooks/useLoadData';
import { ApiResponse } from '../../../models/api-response';

export const RecidentialSingleLotForm = ({ isEdit, enableRequestField }: { isEdit?: boolean, enableRequestField?: boolean }) => {
  const { watch, getValues } = useFormContext();
  const [projectType, projectCommunityType] = watch(['projectType', 'projectCommunityType']);

  if (projectType === ProjectType.Residential && projectCommunityType === ProjectType.ResidentialSingleLot) {
    return (
      <Card elevation={0}>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item lg={4} sm={4} xl={4} xs={4}>
              <FormInput
                name="singleLotJobNumber"
                // label="Job number will generate while saving the data"
                label={(!isEdit || enableRequestField) ? 'Job number will generate while saving the data' : 'Job number'}
                disabled
              />
            </Grid>
            <Grid item lg={4} sm={4} xl={4} xs={4}>
              <FormInput name="singleLotInfo" label="Lot Info" />
            </Grid>
            <Grid item lg={4} sm={4} xl={4} xs={4}>
              <FormInput
                name="singleLotAddress"
                label="Address"
                validationQueryRoute={(value: string) =>
                  projectsApiKeyStore.checkDuplicateLotAddress(getValues('projectID'), value)
                }
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    );
  }
  return null;
};
